import { NoSymbolIcon, UserMinusIcon } from "@heroicons/react/24/outline";
import { Trans } from "@lingui/react/macro";

import { useUserRelation } from "~/hook/overlay/useUserRelation.ts";
import { AButton } from "~/ui/base/AButton.tsx";
import { createWebDraggableSheet } from "~/ui/base/WebDraggableSheet.tsx";

export const WebUserRelationSheet = createWebDraggableSheet<{
  targetUserEmail: string;
}>(({ close, context, titleId }) => {
  const { handleBlock, handleUnfollow } = useUserRelation(
    context.targetUserEmail,
    close,
  );

  return (
    <div className="p-2">
      <h1
        className="px-2 text-lg font-semibold text-zinc-800 dark:text-zinc-100"
        id={titleId}
      >
        @{context.targetUserEmail}
      </h1>
      <ul className="space-y-1 pt-4">
        <li>
          <AButton
            className="flex w-full items-center gap-3 rounded-xl px-2 py-3 duration-150 active:scale-[98%] active:bg-zinc-100 dark:active:bg-zinc-800"
            onClick={handleBlock}
          >
            <NoSymbolIcon className="size-5" />
            <Trans>차단</Trans>
          </AButton>
        </li>
        <li>
          <AButton
            className="flex w-full items-center gap-3 rounded-xl px-2 py-3 duration-150 active:scale-[98%] active:bg-zinc-100 dark:active:bg-zinc-800"
            onClick={handleUnfollow}
          >
            <UserMinusIcon className="size-5" />
            <Trans>팔로우 취소</Trans>
          </AButton>
        </li>
      </ul>
    </div>
  );
});
